import React, { useEffect, useState } from "react";
import allActions from "../../../redux/actions";
import { useSelector, useDispatch } from "react-redux";

// TMS Informations
export function useTmsCourse() { // TMS Course Informations
    const allInfo = useSelector((state: any) => state);
    const dispatch = useDispatch();
    const [isTmsCourse, setTmsCourse] = useState(false);

    useEffect(() => {
        if (!allInfo.tmsCourses.isLoading && !allInfo.tmsCourses.data) {
            dispatch(allActions.tmsCoursesAction.getTMSCourses(allInfo.common.luuId));
            setTmsCourse(true);
        }
    }, [allInfo.common.luuId])

    return [isTmsCourse];
}

export function useTmsLearnerSession() { // TMS Learner Session Informations
    const allInfo = useSelector((state: any) => state);
    const dispatch = useDispatch();
    const [isTmsLearnerSession, setTmsLearnerSession] = useState(false);

    useEffect(() => {
        if (!allInfo.tmsLearnerSessions.isLoading && !allInfo.tmsLearnerSessions.data) {
            dispatch(allActions.tmsLearnerSessionsAction.getStoreTMSLearnerSessionInfo(allInfo.common.luuId));
            setTmsLearnerSession(true);
        }
    }, [allInfo.common.luuId])

    return [isTmsLearnerSession];
}

// Reach Informations
export function useReachProgress() {
    const allInfo = useSelector((state: any) => state);
    const dispatch = useDispatch();
    const [isReach, setReach] = useState(false);

    useEffect(() => {
        if (allInfo.peopleInformation.data && !allInfo.reachProgress.data && !allInfo.reachProgress.isLoading) {
            const { accountId, token }: any = allInfo.peopleInformation.data.getpeopleInformation;
            dispatch(allActions.reachProgressAction.getReachProgress(allInfo.common.leuId, accountId, token));
            setReach(true);
        }
    }, [allInfo.peopleInformation.data, allInfo.common.leuId, allInfo.reachProgress.data])

    return [isReach];
}

// Elevate Informations
export function useElevateLearnerDetails() { // Elevate Learner details
    const allInfo = useSelector((state: any) => state);
    const dispatch = useDispatch();
    const [isElevateLearner, setElevateLearner] = useState(false);

    useEffect(() => {
        if (!allInfo.getLearnerDetails.data && !allInfo.getLearnerDetails.isLoading) {
            dispatch(allActions.getLearnerDetailsAction.getLearnerDetails(allInfo.common.leuId, Number(allInfo.common.productID)))
            setElevateLearner(true)
        }
    }, [allInfo.common.leuId, allInfo.common.productID])

    return [isElevateLearner];
}

export function useElevateAssessmentDetails() { // ElevateAssessment details
    const allInfo = useSelector((state: any) => state);
    const dispatch = useDispatch();
    const [isElevate, setElevate] = useState(false);

    useEffect(() => {
        if (allInfo.elevateAssessmentDetails.data && !allInfo.elevateAssessmentDetails.isLoading) {
            let assessmentDetails = JSON.parse(allInfo.elevateAssessmentDetails.data.getElevateAssessmentDetails);
            const userId = allInfo.peopleInformation.data.getpeopleInformation.edgeUid;
            if (assessmentDetails.length > 0) {
              for (let assessment of assessmentDetails) {
                dispatch(allActions.getElevateTestResultAction.elevateTestResult(Number(userId), assessment.id));
                setElevate(true)
              }
            }
          }
    }, [allInfo.peopleInformation.data, allInfo.elevateAssessmentDetails.data])

    return [isElevate];
}


// Skills Informations

export function useSkillProgress() { // Skill Progress
    const allInfo = useSelector((state: any) => state);
    const dispatch = useDispatch();
    const [isSkillProgress, setSkillProgress] = useState(false);

    useEffect(() => {
        if (!allInfo.skillsProgress.data && !allInfo.skillsProgress.isLoading) {
            dispatch(allActions.skillsProgressAction.getSkillsProgress(allInfo.common.leuId));
            setSkillProgress(true);
        }
    }, [allInfo.peopleInformation.data, allInfo.common.productID, allInfo.skillOutcomeSummary.data])

    return [isSkillProgress];
}

export function useSkillOutcomeSummary() { // Skill Outcome Summary
    const allInfo = useSelector((state: any) => state);
    const dispatch = useDispatch();
    const [isSkillOutcome, setSkillOutcome] = useState(false);

    useEffect(() => {
        if (!allInfo.skillOutcomeSummary.data && !allInfo.skillOutcomeSummary.isLoading) {
            const userId = allInfo.peopleInformation.data.getpeopleInformation.edgeUid;
            dispatch(allActions.skillOutcomeSummaryAction.getSkillOutcome(userId.toString(), Number(allInfo.common.productID)));
            setSkillOutcome(true)
        }
    }, [allInfo.peopleInformation.data, allInfo.common.productID, allInfo.skillOutcomeSummary.data])

    return [isSkillOutcome];
}


// Course Informations
export function useSoloCourse() { // Solo Course
    const allInfo = useSelector((state: any) => state);
    const dispatch = useDispatch();
    const [isSoloCourse, setSoloCourse] = useState(false);

    useEffect(() => {
        if (!allInfo.currentSoloCourseAction.data && !allInfo.currentSoloCourseAction.isLoading) {
            // dispatch(allActions.currentSoloCourseAction.getStoreSoloActiveCourseInfo(allInfo.common.leuId, prod.licenseId, prod.productId));
            setSoloCourse(true);
        }
    }, [allInfo.peopleInformation.data])

    return [isSoloCourse];
}

export function useNonSoloCourse() { // Non Solo Course
    const allInfo = useSelector((state: any) => state);
    const dispatch = useDispatch();
    const [isNonSoloCourse, setNonSoloCourse] = useState(false);

    useEffect(() => {
        if (!allInfo.skillOutcomeSummary.data && !allInfo.skillOutcomeSummary.isLoading) {
            // dispatch(allActions.currentCourseDetailsAction.getStoreActiveCourseInfo(allInfo.common.leuId, prod.licenseId, prod.productId, uuId, courseId));
            setNonSoloCourse(true)
        }
    }, [allInfo.peopleInformation.data])

    return [isNonSoloCourse];
}

// Test Results Informations
export function useTestProgress() { // Test Results
    const allInfo = useSelector((state: any) => state);
    const dispatch = useDispatch();
    const [isTestProgress, setTestProgress] = useState(false);

    useEffect(() => {
        if (!allInfo.testProgressAction?.data && allInfo.peopleInformation?.data && !allInfo.testProgressAction?.isLoading) {
            dispatch(allActions.testProgressAction.getTestProgress(allInfo.common.leuId, allInfo.peopleInformation.data.getpeopleInformation.accountId, Number(allInfo.common.productID)));
            setTestProgress(true)
        }
    }, [allInfo.peopleInformation?.data, allInfo.testProgressAction?.data])

    return [isTestProgress];
}


// Common Informations
export function useProductId() { // Test Results
    const allInfo = useSelector((state: any) => state);
    const dispatch = useDispatch();
    const [isProductId, setProductId] = useState(false);

    useEffect(() => {
        if (!allInfo.peopleInformation.isLoading && allInfo.peopleInformation.data && !sessionStorage.getItem('isDemoUser')) {
            let productId = allInfo.peopleInformation.data.getpeopleInformation.license[0].productId;
            const location = window?.location?.href?.split("/")[4] ?? undefined;
            if (location && allInfo.common.productID !== location) productId = location;
            dispatch(allActions.commonActions.setProductID(productId));
            setProductId(true)
        }
    }, [allInfo.peopleInformation?.data, allInfo.common.productID])

    return [isProductId];
}